// @ constants
const actionTypes = require('constants/contactCenter/actionTypes');

// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');

const sendN1PasswordSuccess = () => ({
   type: actionTypes.SEND_N1_PASSWORD_SET_STEP_SUCCESS
});

const sendN1PasswordError = () => ({
   type: actionTypes.SEND_N1_PASSWORD_SET_STEP_ERROR
});

const postChange = () => (dispatch) => {
    new Promise(() => {

        APIGet(dispatch, apiURLBuilder.getURL('sendN1PasswordByPostMail')).then(
            () =>  {
                dispatch(sendN1PasswordSuccess());
            },
            () => {
                dispatch(sendN1PasswordError());
            }
        );
    });
};

module.exports = {
    postChange
}
